export const enum RetailTableColumnId {
  Name = 'name',
  Email = 'email',
  Phone = 'phone',
  DefaultPayment = 'defaultPayment',
  UnpaidBalance = 'unpaidBalance',
  Credit = 'credit',
  UnpaidInvoices = 'unpaidInvoices',
  BillingAddress = 'billingAddress',
  ShippingAddress = 'shippingAddress',
  LastActivity = 'lastActivity',
  Notes = 'notes',
  Actions = 'actions',
}

export type CardBrand = 'visa' | 'mastercard' | 'amex' | 'discover';

export interface RetailCustomerPayment {
  brand: CardBrand;
  lastFour: string;
}

export interface RetailUnpaidSale {
  id: number;
  idOnMkp: string | null;
  label: string;
  amount: number;
  currency: string;
  salesGroupId: string | null;
}

export interface RetailCustomer {
  id: number;
  name: string;
  email: string;
  phone: string;
  defaultPayment: RetailCustomerPayment | null;
  unpaidBalance: number;
  unpaidSales: RetailUnpaidSale[];
  billingAddress: string;
  shippingAddress: string;
  lastActivity: string | null; // ISO date string or null for empty state
  notes: string;
  salesGroupIds: string[];
  creditBalance: number | null;
  creditCurrencyCode: string | null;
}
